// extracted by mini-css-extract-plugin
module.exports = {"infoIcon":"InfoIconWithPopover_infoIcon__2RV3j"};